<script lang="ts">
	import { Dialog } from '../../Dialog';
	import type { DialogStores } from '../../Dialog';
	import { PlatformList } from '../PlatformList';

	interface Props {
		colored?: boolean | undefined;
		dialogStores: DialogStores;
		onClickPlatform?: ((platform: string) => void) | undefined;
		dataCy: string;
		title?: string;
		link: string;
		intro: string;
		showText?: boolean;
		showTwitter?: boolean;
	}

	let {
		colored = false,
		dialogStores,
		onClickPlatform = undefined,
		dataCy,
		title = 'Share',
		link,
		intro,
		showText = true,
		showTwitter = true
	}: Props = $props();

	let dataCyPrefix = $derived(`${dataCy}-share`);
	let handleCloseDialog = $derived((platform: string) => {
		if (platform !== 'link') {
			dialogStores.states.open.set(false);
		}

		if (onClickPlatform) {
			onClickPlatform(platform);
		}
	});
</script>

<Dialog
	{title}
	{dialogStores}
	dataCy={dataCyPrefix}
	class="xs:max-w-[26rem] max-w-[20rem] p-[1.5rem] pt-[1.25rem] sm:p-[1.5rem] sm:pt-[1rem]"
	titleVariant="h4"
	separator
>
	<PlatformList
		{colored}
		{dataCy}
		onClickPlatform={handleCloseDialog}
		{link}
		{intro}
		{showText}
		{showTwitter}
	/>
</Dialog>
